import { mapGetters, mapActions, mapMutations } from "vuex";

import * as vdpArticleStore from "@/store/VdpArticles";

export { vdpArticleStore };

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createVdpArticleMixin = (without = []) => {
  const actions = !without.includes("actions")
    ? mapActions(vdpArticleStore.moduleName, Object.keys(vdpArticleStore.actionTypes))
    : {};
  const getters = !without.includes("getters")
    ? mapGetters(vdpArticleStore.moduleName, Object.keys(vdpArticleStore.getterTypes))
    : {};
  const mutations = !without.includes("mutations")
    ? mapMutations(vdpArticleStore.moduleName, Object.keys(vdpArticleStore.mutationTypes))
    : {};

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  };
};
